export default {"src":"/_next/static/media/logoBlock6_2.933b5122.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};